var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"dense":"","no-gutters":""}},_vm._l((_vm.datosNew),function(item){return _c('v-col',{key:item.Codigo,attrs:{"cols":"12","sm":_vm.isdrawer ? 12 : 6}},[_c('ItemCar',{attrs:{"item":item}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }